import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { moneyize } from "../../../onestep-library/TextPresenters";

export default function CompletedInvoiceListing(props) {
  const dispatch = useDispatch();
  const { organization } = useSelector((state) => state);
  const {
    name,
    amount,
    is_refunded,
    uuid,
    id,
    last_payment_received_on,
    charges,
    receipts,
    due_date,
  } = props;

  function handleOpenEditPendingInvoice() {
    dispatch({ type: "LOAD_EDIT_PENDING_INVOICE", payload: props });
  }

  return (
    <tr className="hoverable cursor-pointer">
      <td onClick={handleOpenEditPendingInvoice}>
        <div>{getLastPaymentReceivedOn(last_payment_received_on)}</div>
        <StatusBadge
          status={getStatus(is_refunded, due_date, last_payment_received_on)}
        />
      </td>
      <td onClick={handleOpenEditPendingInvoice}>{getDueDate(due_date)}</td>
      <td onClick={handleOpenEditPendingInvoice} className="text-primary">
        {name}
      </td>
      <td onClick={handleOpenEditPendingInvoice}>{moneyize(amount)}</td>
      <td>
        {charges.length == 1 && (
          <ReceiptButton
            receipt={receipts[0]}
            organization_name={organization.name}
            invoiceId={id}
            invoiceUuid={uuid}
          />
        )}
      </td>
    </tr>
  );
}

function getStatus(is_refunded, due_date, last_payment_received_on) {
  if (is_refunded) {
    return "refunded";
  }
  if (!due_date) {
    return "no_due_date";
  } else if (
    moment(due_date).diff(moment(last_payment_received_on), "days") < 0
  ) {
    return "overdue";
  } else {
    return "on_time";
  }
}

function getDueDate(due_date) {
  return !!due_date ? (
    moment(due_date, "YYYY-MM-DD").format("MMMM DD, YYYY")
  ) : (
    <i>No Due Date</i>
  );
}

function getLastPaymentReceivedOn(last_payment_received_on) {
  return last_payment_received_on ? (
    moment(last_payment_received_on, "YYYY-MM-DD").format("MMMM DD, YYYY")
  ) : (
    <i>No Date</i>
  );
}

function StatusBadge({ status }) {
  switch (status) {
    case "overdue":
      return <div className="badge badge-danger">LATE</div>;
    case "on_time":
      return <div className="badge badge-success">ON TIME</div>;
    case "no_due_date":
      return <div className="badge badge-success">PAID</div>;
    case "refunded":
      return <div className="badge bg-secondary">REFUNDED</div>;
  }
}

function ViewReceiptButton({ href }) {
  return (
    <a
      target="_blank"
      href={href}
      className="btn btn-primary btn-small text-white"
    >
      View Receipt
    </a>
  );
}

const ReceiptButton = ({
  organization_name,
  receipt,
  invoiceId,
  invoiceUuid,
}) => {
  const href = receipt
    ? `/organizations/${organization_name}/receipts/${receipt.id}?tkn=${receipt.uuid}`
    : `/organizations/${organization_name}/invoices/${invoiceId}/receipt?tkn=${invoiceUuid}`;
  return <ViewReceiptButton href={href} />;
};
